import { r as registerInstance, h } from './index-d4808923.js';

const gravityProgressSegmentedCss = ".progress-segmented{display:flex;gap:4px;height:2px;justify-content:space-between;overflow:hidden;width:100%}.progress-segmented__segment{border-radius:2px;flex:1;height:2px}.progress-segmented__segment--complete.progress-segmented--primary{background-color:#1B6AEE}.progress-segmented__segment--complete.progress-segmented--secondary{background-color:rgba(0, 15, 30, 0.6)}.progress-segmented__segment--complete.progress-segmented--warning{background-color:#FF9000}.progress-segmented__segment--complete.progress-segmented--danger{background-color:#DB0A40}.progress-segmented__segment--empty{background-color:rgba(0, 15, 30, 0.1)}";
const GravityProgressSegmentedStyle0 = gravityProgressSegmentedCss;

const GravityProgressSegmented = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.completed = 1;
        this.segment = 2;
        this.type = 'primary';
    }
    render() {
        let states = [];
        for (let i = 0; i < this.segment; i++) {
            states = i < this.completed ? [...states, 'complete'] : [...states, 'empty'];
        }
        return (h("div", { key: 'e6c85f7de92782c9d9e1cf7441f66c324591aece', class: `progress-segmented progress-segmented--${this.type}` }, states.map((state) => (h("div", { class: `progress-segmented__segment progress-segmented__segment--${state} progress-segmented--${this.type}` })))));
    }
};
GravityProgressSegmented.style = GravityProgressSegmentedStyle0;

export { GravityProgressSegmented as gravity_progress_segmented };

//# sourceMappingURL=gravity-progress-segmented.entry.js.map